import { onViewChange, allToTallest, queryAll } from '@/resources/assets/js/modules/utils';

if (window.innerWidth > 991) {
  setTimeout(() => {
    queryAll('.AccordionSection').forEach(Accordion => {
      const accordionButton = [...Accordion.querySelectorAll('.Accordion-item button')]
      if (accordionButton.length) {
        allToTallest(accordionButton);
        onViewChange(allToTallest.bind(this, accordionButton))
      }
    })
  }, 100);
}
